import {
  Button,
  CardBody,
  HeaderWithAlert,
  PopUpInformative,
} from 'components';
import FormCouponPrice from 'components/organisms/Form-cupon-price/Form-cupon-price';
import { useFormCuponPrice } from 'components/organisms/Form-cupon-price/hooks/Form-cupon-price.hook';
import { useState } from 'react';
import './Add-subscription.scss';
import AvailableAddons from './componentes/AvailableAddons';
import CardPrice from './componentes/CardPrice';
import { PaymentMethod } from './componentes/PaymentMethod';
import { PropertyDetails } from './componentes/PropertyDetails';
import { PurchaseSummary } from './componentes/PurchaseSummary';
import { SubscriptionPeriodSelector } from './componentes/SubscriptionPeriodSelector';
import { useAddSubscription } from './hooks/Add-subscription.hook';

export const AddSubscription = () => {
  /* coupon */
  const {
    couponError,
    appliedCoupon,
    couponCode,
    loadingCoupon,
    resetCoupon,
    handleCouponCode,
    handleApplyCoupon,
  } = useFormCuponPrice();

  /* credit card */
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState<string | null>(null);

  const {
    steps,
    navigate,
    products,
    vehicleData,
    loading,
    error,
    period,
    counts,
    selectedAddons,
    isFormValid,
    formData,
    handleCount,
    handleAddonToggle,
    calculatePrice,
    formatCurrency,
    getAdvantages,
    handleFormValidChange,
    handlePurchase,
    isAnyProductSelected,
    setPeriod,
    setFormData,
    subtotal,
    isPurchasing,
    showAlertError,
    setShowAlertError,
  } = useAddSubscription({ appliedCoupon, selectedPaymentMethod });

  if (loading) return <div>Cargando productos...</div>;
  if (error) return <div>Hubo un error al traer productos con sus prices</div>;

  return (
    <>
      {showAlertError && (
        <PopUpInformative
          title={'Error'}
          text={showAlertError}
          type="error"
          closePopUp={() => setShowAlertError(null)}
        ></PopUpInformative>
      )}
      <HeaderWithAlert
        steps={steps}
        onClick={() => navigate('/settings')}
      ></HeaderWithAlert>
      <div className="add-subscription__header">
        <h6>Agregar suscripción</h6>
      </div>
      <main
        className="add-subscription__container container__generic"
        role="main"
        aria-label="Agregar suscripción"
      >
        <SubscriptionPeriodSelector
          period={period}
          onChangePeriod={(value) => setPeriod(value as 'Mensual' | 'Anual')}
        />

        <CardBody>
          {products
            .filter((product) => !product.is_addon)
            .map((product) => (
              <div key={product.id}>
                {product.prices
                  .filter((price) => price.periocity_id.name === period)
                  .map((price) => (
                    <CardPrice
                      key={price.id}
                      price={price}
                      product={product}
                      counts={counts}
                      handleCount={handleCount}
                      getAdvantages={getAdvantages}
                      calculatePrice={calculatePrice}
                      formatCurrency={formatCurrency}
                    />
                  ))}
              </div>
            ))}
        </CardBody>

        <AvailableAddons
          getAdvantages={getAdvantages}
          products={products}
          period={period}
          counts={counts}
          selectedAddons={selectedAddons}
          handleAddonToggle={handleAddonToggle}
        />

        <PropertyDetails
          counts={counts}
          prices={products.flatMap((p) => p.prices)}
          period={period}
          onValidChange={handleFormValidChange}
          formData={formData}
          setFormData={setFormData}
          vehicleData={vehicleData}
        />

        <PaymentMethod onSelectPaymentMethod={setSelectedPaymentMethod} />

        <FormCouponPrice
          couponCode={couponCode}
          appliedCoupon={appliedCoupon}
          couponError={couponError}
          handleCouponCode={handleCouponCode}
          isAnyProductSelected={isAnyProductSelected}
          resetCoupon={resetCoupon}
          handleApplyCoupon={handleApplyCoupon}
          loadingCoupon={loadingCoupon}
        />

        <PurchaseSummary
          products={products}
          period={period}
          selectedAddons={selectedAddons}
          counts={counts}
          formatCurrency={formatCurrency}
          calculatePrice={calculatePrice}
          subtotal={subtotal}
          appliedCoupon={appliedCoupon}
        />

        <Button
          color="primary"
          size="medium"
          template="primary"
          typeStyle="rounded"
          className="success"
          type="button"
          onClick={handlePurchase}
          isDisabled={
            !isFormValid ||
            Object.values(counts).every((count) => count === 0) ||
            !selectedPaymentMethod ||
            isPurchasing
          }
        >
          {isPurchasing ? 'Procesando compra...' : 'Comprar'}
        </Button>
      </main>
    </>
  );
};
